<template>

    <div>

        <XModal ref="XModal" :full-transparent="true" :hide-footer="true" :show-close-button="allowClose"
                :show-overlay="true">

            <Message :closable="false" :severity="severity" class="mb-1">{{ this.message }}</Message>
            <ProgressBar v-if="showProgressBar" class="mt-0" mode="indeterminate" style="height: 3px;"/>

        </XModal>

    </div>

</template>

<script>
import XModal from "./XModal";
import AppEventBus from "../../utils/AppEventBus";

export default {
    name: "BlockNotify",
    components: {XModal},
    data() {
        return {
            message: '',
            severity: 'info',
            showProgressBar: true,
            allowClose: false,
            messagesStack: [],
        }
    },
    methods: {

        show() {
            this.$refs.XModal.show();
        },
        hide() {
            this.$refs.XModal.hide();
        },

        showBlockModal([$text, $severity = 'info', $showProgressBar = true, $allowClose = false, $addToStack = true]) {

            if ($addToStack)
                this.messagesStack.push([$text, $severity, $showProgressBar, $allowClose])

            this.allowClose = $allowClose;
            this.message = $text;
            this.severity = $severity;
            this.showProgressBar = $showProgressBar;
            this.show();

        },

        hideBlockModal() {

            this.messagesStack.pop()

            const lastElement = this.messagesStack.slice(-1).pop()

            if (lastElement && Array.isArray(lastElement) && lastElement.length) {
                this.showBlockModal([...lastElement, false])
            } else {
                this.hide();
            }

        },

    },
    mounted() {
        AppEventBus.on('showBlockModal', this.showBlockModal);
        AppEventBus.on('hideBlockModal', this.hideBlockModal);
    },
    unmounted() {
        AppEventBus.off('showBlockModal', this.showBlockModal);
        AppEventBus.off('hideBlockModal', this.hideBlockModal);
    }
}
</script>

<style scoped>

</style>